import { useCallback } from 'react';
import { useKBar } from 'kbar';
import SearchBar from 'components/common/search-bar';
import styled from 'types/theme.types';
import useOperatingSystem from 'hooks/use-operating-system';

const noop = () => {};

// Figma's Search bar instance in Navigation/Top is 140px; the wrapper otherwise fills its container.
const PaletteSearchBar = styled(SearchBar)`
  width: 140px;
`;

export const KbarSearchButton = () => {
  const { query } = useKBar();
  const { isMacOs } = useOperatingSystem();

  const toggleKbar = useCallback(() => query?.toggle(), [query]);

  /**
   * Figma's top bar puts the command palette behind the Search bar component, not a button. The field
   * is read-only and opens kbar on click, so there is nothing to filter — APO-458 owns the field's own
   * restyle and this call site inherits it, the left-hand magnifier included.
   *
   * `allowClear={false}` because APO-458 defaults it on for every new-design field: a read-only
   * trigger has nothing to clear, so the cross would be a dead control.
   */
  return (
    <PaletteSearchBar
      data-e2e="search-button"
      readOnly
      allowClear={false}
      // Without this TextInput reserves a line below the input for the error message, which lifts
      // the field ~10px above the rest of the cluster. A palette trigger has no validation state.
      hideError
      onFilter={noop}
      onClick={toggleKbar}
      placeholder="topbar.search.placeholder"
      placeholderValues={{ shortcut: isMacOs ? '⌘' : 'Ctrl' }}
    />
  );
};
